import { call, put } from 'redux-saga/effects';

import { fetchBetaNodes } from 'api/WorkflowsAPI';
import { addNegativeToastWithErrorId } from 'modules/toastContainer';
import { getErrorResponse } from 'utils/xhr';
import { actions } from '../actions';

export default function* fetchBetaNodesSaga() {
  try {
    const response: { supported: string[]; unsupported: string[] } = yield call(fetchBetaNodes);
    yield put(actions.fetchBetaNodesResponse(response));
  } catch (error) {
    const err = getErrorResponse(error);
    yield put(actions.fetchBetaNodesError(err));
    const message = `Error fetching beta nodes. Please try again later.`;
    yield put(addNegativeToastWithErrorId(message, 'fetchBetaNodesSaga'));
  }
}
